module.exports = __webpack_public_path__ + "media/images/aloe/illustrations/profile-f46ecb40dffa7c3bd61945193f8c2496.svg";